import { __ } from '@wordpress/i18n';
import { twMerge } from 'tailwind-merge';

const RULE_STATUS_STYLES: Record< string, string > = {
    publish: 'bg-[#D4FBEF] text-[#00563F] border-[#00563F]',
    published: 'bg-[#D4FBEF] text-[#00563F] border-[#00563F]',
    draft: 'bg-[#F1F1F4] text-[#393939] border-[#393939]',
    trash: 'bg-[#F8E3E6] text-[#9F2225] border-[#9F2225]',
    pending: 'bg-[#F8DDA7] text-[#94660C] border-[#94660C]',
    future: 'bg-[#E5E7EB] text-[#111827] border-[#111827]',
    private: 'bg-[#E5E7EB] text-[#111827] border-[#111827]',
};

const STATUS_LABELS: Record< string, string > = {
    publish: __( 'Published', 'dokan' ),
    draft: __( 'Draft', 'dokan' ),
    trash: __( 'Trash', 'dokan' ),
    pending: __( 'Pending', 'dokan' ),
    future: __( 'Scheduled', 'dokan' ),
    private: __( 'Private', 'dokan' ),
};

const StatusPill = ( {
    value,
    editMode = false,
}: {
    value: string;
    editMode: boolean;
} ) => {
    const label =
        STATUS_LABELS[ value ] ||
        ( value
            ? value.charAt( 0 ).toUpperCase() + value.slice( 1 )
            : __( 'Draft', 'dokan' ) );
    return (
        <div className="inline-flex items-center min-w-48">
            <span
                className={ twMerge(
                    `inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border`,
                    RULE_STATUS_STYLES[ value ] || 'bg-gray-100 text-gray-700',
                    ! editMode && 'border-none'
                ) }
            >
                { label }
            </span>
        </div>
    );
};

export default StatusPill;
